/**
 * Flex-wrap container for chip cells so multi-line chip groups stay centered
 * inside auto-height DataGrid rows.
 */
import React from "react";
import { Box } from "@mui/material";

const CHIP_CELL_SX = {
  display: "flex",
  flexWrap: "wrap",
  gap: 0.5,
  alignItems: "center",
  justifyContent: "center",
  py: 0.25,
  width: "100%",
} as const;

export function ChipCellContainer({
  children,
}: {
  readonly children?: React.ReactNode;
}) {
  return <Box sx={CHIP_CELL_SX}>{children}</Box>;
}
